import React, {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';

interface TimeZoneContextProps {
  timeZone: string;
}

const TimeZoneContext = createContext<TimeZoneContextProps | undefined>(
  undefined
);

interface TimeZoneProviderProps {
  settings: Record<string, any>;
  dataUpdatedAt: number | null;
  children: ReactNode;
}

export const TimeZoneProvider = ({
  settings,
  dataUpdatedAt,
  children,
}: TimeZoneProviderProps) => {
  const [timeZone, setTimeZone] = useState<string>('UTC');

  useEffect(() => {
    if (settings) {
      const newTimeZone =
        settings?.['ribbonPlugin.settings']?.time_zone || 'UTC';
      if (newTimeZone && newTimeZone !== timeZone) {
        setTimeZone(newTimeZone);
      }
    }
  }, [dataUpdatedAt, settings, timeZone]);

  const value = useMemo(
    () => ({
      timeZone,
    }),
    [timeZone]
  );

  return (
    <TimeZoneContext.Provider value={value}>
      {children}
    </TimeZoneContext.Provider>
  );
};

export const useTimeZoneContext = () => {
  const context = useContext(TimeZoneContext);
  if (context === undefined) {
    throw new Error(
      'useTimeZoneContext must be used within a TimeZoneProvider'
    );
  }
  return context;
};
